const isoLanguages = [
  {
    code: "cmn",
    name: "Mandarin",
  },
  {
    code: "es",
    name: "Spanish",
  },
  {
    code: "en",
    name: "English",
  },
  {
    code: "hi",
    name: "Hindi",
  },
  {
    code: "ar",
    name: "Arabic",
  },
  {
    code: "pt",
    name: "Portuguese",
  },
  {
    code: "bn",
    name: "Bengali",
  },
  {
    code: "ru",
    name: "Russian",
  },
  {
    code: "ja",
    name: "Japanese",
  },
  {
    code: "pa",
    name: "Panajabi",
  },
  {
    code: "de",
    name: "German",
  },
  {
    code: "jv",
    name: "Javanese",
  },
  {
    code: "wuu",
    name: "Wu Chinese",
  },
  {
    code: "ms",
    name: "Malay",
  },
  {
    code: "te",
    name: "Telugu",
  },
  {
    code: "vi",
    name: "Vietnamese",
  },
  {
    code: "ko",
    name: "Korean",
  },
  {
    code: "fr",
    name: "French",
  },
  {
    code: "mr",
    name: "Marathi",
  },
  {
    code: "ta",
    name: "Tamil",
  },
  {
    code: "ur",
    name: "Urdu",
  },
  {
    code: "tr",
    name: "Turkish",
  },
  {
    code: "it",
    name: "Italian",
  },
  {
    code: "yue",
    name: "Cantonese",
  },
  {
    code: "th",
    name: "Thai",
  },
  {
    code: "gu",
    name: "Gujarati",
  },
  {
    code: "mnp",
    name: "Chinese Min Bei",
  },
  {
    code: "fa",
    name: "Farsi",
  },
  {
    code: "pl",
    name: "Polish",
  },
  {
    code: "ps",
    name: "Pushto",
  },
  {
    code: "hsn",
    name: "Hunanese",
  },
  {
    code: "ml",
    name: "Malayalam",
  },
  {
    code: "my",
    name: "Burmese",
  },
  {
    code: "hak",
    name: "Hakka Chinese",
  },
  {
    code: "uk",
    name: "Ukrainian",
  },
  {
    code: "fil",
    name: "Filipino",
  },
  {
    code: "ro",
    name: "Romanian",
  },
  {
    code: "nl",
    name: "Dutch",
  },
  {
    code: "ku",
    name: "Kurdish",
  },
  {
    code: "hr",
    name: "Croatian",
  },
  {
    code: "hu",
    name: "Hungarian",
  },
  {
    code: "el",
    name: "Greek",
  },
  {
    code: "cs",
    name: "Czech",
  },
  {
    code: "sv",
    name: "Swedish",
  },
  {
    code: "fi",
    name: "Finnish",
  },
  {
    code: "sk",
    name: "Slovak",
  },
  {
    code: "sr",
    name: "Serbian",
  },
  {
    code: "no",
    name: "Norwegian",
  },
  {
    code: "he",
    name: "Hebrew",
  },
  {
    code: "da",
    name: "Danish",
  },
  {
    code: "zh_TW",
    name: "Chinese Traditional",
  },
  {
    code: "zh_CN",
    name: "Chinese Simplified",
  },
  {
    code: "id",
    name: "Indonesian",
  },
];

export default isoLanguages;
